import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_mountain_blue/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-4258fa3497.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-12dc1e8887.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-7965d545b0.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-6f24afb3a2.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-6bc6539522.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-327a976c7d.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-1329c468a6.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-4e74cf8e9d.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-19f2ec6eb4.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-155642e46c.png'; };
